import request from '@/utils/request'

export function fetchList(params) {
    return request({
        url: '/product/list',
        method: 'get',
        params: params
    })
}

export function deleteProduct(id) {
    return request({
        url: '/product/delete/' + id,
        method: 'delete',
    })
}

export function createProduct(data) {
    return request({
        url: '/product/create',
        method: 'post',
        data: data
    })
}

export function updateProduct(id, data) {
    return request({
        url: '/product/update/' + id,
        method: 'post',
        data: data
    })
}


export function createProductComponent(data) {
    return request({
        url: '/component/create',
        method: 'post',
        data: data
    })
}

export function updateProductComponent(id, data) {
    return request({
        url: '/component/update/' + id,
        method: 'post',
        data: data
    })
}


export function deleteComponent(id) {
    return request({
      url:'/component/delete/'+ id,
      method:'delete',
    })
  }
  
  

export function getProduct(id) {
    return request({
        url: '/product/updateInfo/' + id,
        method: 'get',
    })
}


export function getProductHistoryDetails(id) {
    return request({
        url: '/product/historyDetails/' + id,
        method: 'get',
    })
}


export function calcualteProduct(id) {
    return request({
        url: '/product/calculate/' + id,
        method: 'get',
    })
}


export function getProductByLotNo(lotNo) {
    return request({
        url: '/product/lotNo/' + lotNo,
        method: 'get'
    })
}




export function fetchProductComponentListByLotNo(params) {
    return request({
        url: '/component/list',
        method: 'get',
        params : params
    })
}


export function fetchProductHistory(params,id) {
    return request({
      url:'/product/history/'+ id,
      method:'get',
      params:params
    })
  }

  
  
export function fetchProductComponentHistory(params,id) {
    return request({
      url:'/component/history/'+ id,
      method:'get',
      params:params
    })
  }
  

  

  export function printPriceTag(ids,params) {
    return request({
      url:'/product/printPriceTag',
      method:'post',
      data: ids,
      params:params
    })
  }